import { z } from 'zod/v4';

const coordinate = z.object({
  lat: z.number().min(-90).max(90),
  lng: z.number().min(-180).max(180),
});

/** Installer-labelled reference, never an automatic ridge/eave classification. */
export const solarRoofEdgeAnchorSchema = z.object({
  edgeIndex: z.number().int().nonnegative().max(499),
  endpoints: z.tuple([coordinate, coordinate]),
  role: z.enum(['ridge', 'eave']),
  offsetM: z.number().nonnegative().max(100),
});
export type SolarRoofEdgeAnchor = z.infer<typeof solarRoofEdgeAnchorSchema>;

/** Exact endpoint identity survives JSON copies, but never snaps to a new edge. */
export const roofEdgeAnchorIsValid = (
  anchor: SolarRoofEdgeAnchor,
  outer: Array<{ lat: number; lng: number }>
): boolean => {
  if (outer.length < 3 || anchor.edgeIndex >= outer.length) return false;
  return (
    anchor.endpoints.every((point, index) => {
      const vertex = outer[(anchor.edgeIndex + index) % outer.length];
      return point.lat === vertex.lat && point.lng === vertex.lng;
    }) &&
    (anchor.endpoints[0].lat !== anchor.endpoints[1].lat ||
      anchor.endpoints[0].lng !== anchor.endpoints[1].lng)
  );
};
